import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({ name: 'formatDateFromNow' })
export class FormatDateFromNowPipe implements PipeTransform {
    transform(value: any): string {
        return moment(value).fromNow()
    }
}
